import partner from '../other/partner';
import bill from './bill';
import document from './document';
import payment from './payment';

const abo = `
    billings {
        ${bill}
    }
    cancellation
    cancelReasonAlternative
    cancelReasonOther
    cancelReasons
    confirmation {
        ${document}
    }
    created
    externalAbo {
        id
        type
    }
    externalSubscription {
        status
    }
    firstperiod
    getFirstPeriod
    getFinishDate
    getLatestCancellationDateForCurrentPeriod
    id
    incomingPayments {
        ${payment}
    }
    locked
    partner {
        ${partner}
    }
    partnerId
    planId
    price
    referrerCode
    revoked
    sales
    start
`;

export default abo;
